import React__default from 'react';
import classnames from 'classnames';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector, statusSuccess } from '@grandvisionhq/state';
import PrescriptionForm from './PrescriptionForm.js';
import { getSelectedFrame, getPrescription, getPrescriptionType, getManualPrescriptionValidationState } from '../../../../../state/configurator/selectors.js';
import { updatePrescriptionValue } from '../../../../../state/configurations/actions.js';

const PrescriptionFormContainer = ({ className  })=>{
    const dispatch = useDispatch();
    const { goToNextStep , hasAttemptedNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const handleChange = React__default.useCallback((side)=>(parameter, value)=>{
            if (!frame) {
                return;
            }
            dispatch(updatePrescriptionValue({
                side,
                frameSku: frame.sku,
                parameter,
                value
            }));
        }
    , [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    const prescription = useSelector(getPrescription);
    const prescriptionType = useSelector(getPrescriptionType);
    const manualPrescriptionValidationState = useSelector(getManualPrescriptionValidationState);
    const isSubmitted = hasAttemptedNextStep;
    const isEnabled = !prescriptionType || CommerceToolsApi.isNewPrescription(prescriptionType);
    const handleRightChange = React__default.useCallback(handleChange('right'), [
        handleChange
    ]);
    const handleLeftChange = React__default.useCallback(handleChange('left'), [
        handleChange
    ]);
    if (!statusSuccess(prescription) || !frame) {
        // Loading / error states are handled further up the tree
        return null;
    }
    const { left , right , parameters  } = prescription.result;
    const shouldDisplayValidationError = isSubmitted && isEnabled ? manualPrescriptionValidationState : undefined;
    return /*#__PURE__*/ React__default.createElement(PrescriptionForm, {
        className: classnames('prescription-step__form', className),
        opticalParameters: parameters,
        prescription: {
            left,
            right
        },
        prescriptionValidationState: shouldDisplayValidationError,
        idExtension: frame.sku,
        setLeftParameter: handleLeftChange,
        setRightParameter: handleRightChange,
        isSubmitted: isSubmitted,
        isDisabled: !isEnabled,
        onSubmit: goToNextStep
    });
};

export { PrescriptionFormContainer };
//# sourceMappingURL=PrescriptionFormContainer.js.map
